import { IConditionBody as IAdvancedSearchSetting } from 'pages/ApprovalDocumentGroup/approvalDocumentList/advancedSearch/type';

export const types = {
  SAVE_ADVANCED_SEARCH_SETTINGS: 'SAVE_ADVANCED_SEARCH_SETTINGS' as const,
  CLEAR_ADVANCED_SEARCH_SETTINGS: 'CLEAR_ADVANCED_SEARCH_SETTINGS' as const,
};

export const saveApprovalDocumentAdvancedSearchSettings = (payload: IAdvancedSearchSetting[]) => ({
  type: types.SAVE_ADVANCED_SEARCH_SETTINGS,
  payload,
});
export const clearApprovalDocumentAdvancedSearchSettings = (payload: [] = []) => ({
  type: types.CLEAR_ADVANCED_SEARCH_SETTINGS,
  payload,
});

export type Actions = (
  ReturnType<typeof saveApprovalDocumentAdvancedSearchSettings>
  | ReturnType<typeof clearApprovalDocumentAdvancedSearchSettings>
);
